<ng-container *ngIf="isString(text)">{{ text | translate }}</ng-container>
<ng-container *ngIf="!isString(text)">{{ text | customFieldLabel : (uiLanguage$ | async) }}</ng-container>
